<template>
    <!--    <button @click="onClick">Go to NSI</button>-->
    <reg-grid
        id="ai-reg-grid"
        :viewName="name"
        :keyExpr="key"
        :custom-context-menu="customContextMenu"
        :dbSchema="matview_schema"
        :dbSource="matview"
        :cardName="cardName"
        :toolbarMeta="toolbarMeta"
        :selection-mode="settings?.selectionMode"
        apiGetList="contract-list/data/get"
        :toolbar-show="settings?.toolbarShow !== undefined ? settings?.toolbarShow : true"
        :filterPanelShow="settings?.filterPanelShow !== undefined ? settings?.filterPanelShow : true"
        :total-count-selected-show="
            settings?.totalCountSelectedShow !== undefined ? settings?.totalCountSelectedShow : true
        "
        :filter-row="settings?.filterRow !== undefined ? settings?.filterRow : true"
        :findText="findText"
    >
    </reg-grid>
</template>

<script>
import RegGrid from '@/virtual/reg-grid.vue';
import { useRouter } from 'vue-router';
import { saveUserDataChanges } from '@/service/userdata-service';

export default {
    name: 'view-contract-list-old',
    props: {
        settings: {
            type: Object,
            default: () => {
                return {
                    toolbarShow: true,
                    filterPanelShow: true,
                    selectionMode: 'multiple',
                    totalCountSelectedShow: true,
                    filterRow: { visible: true },
                };
            },
        },
        findText: {
            type: String,
            default: () => {
                return '';
            },
        },
    },
    setup() {
        const router = useRouter();

        const onClick = async () => {
            const args = {
                viewId: 'nsi-view',
                instanceId: null,
                changes: {
                    isButtonVisible: true,
                },
            };
            await saveUserDataChanges(args);
            router.push({
                name: 'ks-spos-opl',
            });
        };

        return {
            name: 'view-kv-dogovor-reestr',
            matview_schema: 'dog',
            matview: 'mvi_kv_dogovor_reestr',
            key: 'kod_dog',
            cardName: 'contract-card-view',
            selectionMode: 'multiple',
            toolbarMeta: {
                columnChooserButton: {
                    visible: true,
                },
            },
            customContextMenu: [
                {
                    name: 'gotoCard2',
                    text: 'Посмотреть карточку',
                    visible: true,
                    onItemClick: e => {
                        const id = e.itemData.rowData.key;
                        router.push({
                            name: 'contract-card-view',
                            params: { id },
                        });
                    },
                },
            ],
            onClick,
        };
    },
    components: {
        RegGrid,
    },
};
</script>
